/** @format */

import React, { FunctionComponent, useState } from 'react'
import { _$, Card, Icon } from '@king-design/react'
import PinText from '../../components/PinText'
import ListItem from './GeneralListItem'
import styled from 'styled-components'
import { useAsync } from 'react-use'
import { GetResource } from 'src/api/ApiGeneral'
// 告警资源部分
const Resource: FunctionComponent<any> = ({ className }) => {
  const [extend, setExtend] = useState<boolean>(false)

  const { value: resourceList } = useAsync(async () => {
    const resSource = await GetResource()
    return resSource?.data?.resourceList
  }, [])
  const title = (
    <div className="title">
      <h4>{_$('资源概览')}</h4>
      <PinText text={_$('正在告警')} color="#ff4433" className="alarm_source" />
      <PinText text={_$('所有资源')} className="all_source" />
    </div>
  )

  return (
    <Card className={className} slotTitle={title} type="none">
      <div className="content">
        <div className={extend ? 'list extend' : 'list'}>
          {resourceList &&
            Array.isArray(resourceList) &&
            resourceList.map(item => <ListItem key={item.productName} content={item} />)}
        </div>
        {resourceList?.length > 15 && !extend && (
          <p
            className="extend-btn"
            onClick={() => {
              setExtend(true)
            }}
          >
            {_$('展开全部')}
            <Icon className="ion-chevron-down" size="mini" />
          </p>
        )}
        {resourceList?.length > 15 && extend && (
          <p
            className="extend-btn"
            onClick={() => {
              setExtend(false)
            }}
          >
            {_$('部分收起')}
            <Icon className="ion-chevron-up" size="mini" />
          </p>
        )}
      </div>
    </Card>
  )
}

export default styled(Resource)`
  position: relative;
  padding-bottom: 20px;
  .title {
    font-size: 14px;
    position: relative;
    height: 38px;
    line-height: 38px;
    h4 {
      display: inline;
      font-size: 14px;
    }
    .alarm_source {
      font-size: 12px;
      margin-left: 20px;
    }
    .all_source {
      font-size: 12px;
      margin-left: 16px;
    }
  }
  .content {
    .list {
      display: grid;
      grid-template-columns: 33% 33% 33%;
      max-height: 180px;
      overflow: hidden;
      &.extend {
        max-height: 9999px;
      }
      .source_content_list {
        padding: 0px 16px;
        font-size: 14px;
        position: relative;
        ::after {
          content: '';
          width: 2px;
          height: 190px;
          border: 1px solid #e5e5e5;
          position: absolute;
          right: 0px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .source_content_list:nth-child(3)::after {
        display: none;
      }
    }
    .extend-btn {
      position: absolute;
      display: inline-block;
      cursor: pointer;
      transform: translateX(-50%);
      margin-bottom: 0;
      bottom: 8px;
      left: 50%;
      .k-icon {
        margin-left: 4px;
      }
    }
  }
`
